import { render, staticRenderFns } from "./NameSvg.vue?vue&type=template&id=601bbe2d&"
import script from "./NameSvg.vue?vue&type=script&lang=js&"
export * from "./NameSvg.vue?vue&type=script&lang=js&"
import style0 from "./NameSvg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports